import store from '@/store';
import base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async collect(guidelineId) {
    const data = {
      factory: store.state.app.factory.id,
    };
    const res = await base.create({
      url: `collect/guideline/${guidelineId}`,
      data,
    });
    return res;
  },
  async unCollect(guidelineId) {
    const data = {
      factory: store.state.app.factory.id,
    };
    const res = await base.create({
      url: `uncollect/guideline/${guidelineId}`,
      data,
    });
    return res;
  },
  async show(guidelineId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.show({
      modelName: 'guideline',
      modelId: guidelineId,
      params,
    });
    return res;
  },
}